export default __webpack_public_path__ + "static/media/icon-infusion-bottle-half.27f1c4c9.svg";